import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "../../assets/css/privacy.css";

const Privacy = () => {
	return (
		<>
			<Header />
			{/* Page Header starts here */}
			<section className="page-header">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<h2>Privacy Policy</h2>
							<span>Home {">"} Privacy Policy</span>
						</div>
					</div>
				</div>
			</section>
			{/* Page Header ends here */}
			{/* Privacy starts here */}
			<section className="privacy-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="content-wrapper">
								<div className="row">
									<div className="col-lg-8">
										<div className="heading-wrapper">
											<h3>Privacy Policy for The studio 2 pro</h3>
										</div>
									</div>
								</div>

								<div className="privacy-content-wrapper">
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et dolore magna
										aliqua. Malesuada fames ac turpis egestas integer eget
										aliquet. Placerat orci nulla pellentesque dignissim. Netus
										et malesuada fames ac turpis. Enim praesent elementum
										facilisis leo vel fringilla est ullamcorper. Neque aliquam
										vestibulum morbi blandit cursus risus at. Eget nunc lobortis
										mattis aliquam. Semper auctor neque vitae tempus quam.
										Tempor id eu nisl nunc mi ipsum faucibus. Diam quis enim
										lobortis scelerisque fermentum dui faucibus. Nisi est sit
										amet facilisis magna. Elementum pulvinar etiam non quam
										lacus suspendisse faucibus interdum posuere. Sit amet purus
										gravida quis blandit turpis cursus. Non curabitur gravida
										arcu ac tortor dignissim convallis aenean. Scelerisque in
										dictum non consectetur a erat nam at. Elit ut aliquam purus
										sit amet luctus.
									</p>
									<p>
										Pretium aenean pharetra magna ac. Proin fermentum leo vel
										orci porta non pulvinar. Sed enim ut sem viverra aliquet.
										Nullam non nisi est sit amet facilisis magna etiam. Enim sit
										amet venenatis urna. Nisi scelerisque eu ultrices vitae
										auctor eu augue ut lectus. Ac turpis egestas integer eget
										aliquet. Erat nam at lectus urna duis convallis convallis
										tellus. Id venenatis a condimentum vitae sapien. Et odio
										pellentesque diam volutpat commodo sed. Dictum sit amet
										justo donec enim diam vulputate ut. Commodo ullamcorper a
										lacus vestibulum. Quam nulla porttitor massa id neque
										aliquam vestibulum morbi blandit. Nec feugiat in fermentum
										posuere urna nec.
									</p>
									<p>
										Consequat nisl vel pretium lectus quam id. Nam at lectus
										urna duis convallis convallis tellus. Donec ac odio tempor
										orci dapibus. Sit amet consectetur adipiscing elit. Purus in
										mollis nunc sed id semper risus in hendrerit. At ultrices mi
										tempus imperdiet nulla malesuada pellentesque elit. Mattis
										aliquam faucibus purus in massa. Sed risus pretium quam
										vulputate dignissim suspendisse. Et ligula ullamcorper
										malesuada proin libero nunc consequat. Sem nulla pharetra
										diam sit amet nisl suscipit adipiscing bibendum. Odio ut sem
										nulla pharetra diam sit amet. Eget nullam non nisi est sit
										amet facilisis magna. Venenatis lectus magna fringilla urna
										porttitor rhoncus dolor purus non. Blandit turpis cursus in
										hac habitasse platea dictumst. Volutpat est velit egestas
										dui id. Aliquam faucibus purus in massa tempor. Rhoncus
										dolor purus non enim praesent elementum facilisis. Nullam
										vehicula ipsum a arcu cursus vitae congue mauris.
									</p>
									<p>
										In mollis nunc sed id semper risus. Tortor posuere ac ut
										consequat semper viverra. Maecenas sed enim ut sem.
										Vestibulum lorem sed risus ultricies tristique nulla aliquet
										enim tortor. Faucibus ornare suspendisse sed nisi. Cursus
										euismod quis viverra nibh. In arcu cursus euismod quis
										viverra nibh. Nunc sed id semper risus in hendrerit gravida
										rutrum quisque. Lorem ipsum dolor sit amet. Est ultricies
										integer quis auctor elit sed vulputate. Etiam sit amet nisl
										purus. Vel facilisis volutpat est velit egestas dui id.
										Molestie nunc non blandit massa enim nec dui nunc mattis.
										Fermentum iaculis eu non diam phasellus vestibulum lorem
										sed. Quis commodo odio aenean sed adipiscing diam. Tellus
										orci ac auctor augue mauris augue neque. Nisi scelerisque eu
										ultrices vitae auctor. Convallis aenean et tortor at risus
										viverra. Neque egestas congue quisque egestas diam in arcu
										cursus. Ultrices sagittis orci a scelerisque purus semper
										eget.
									</p>
									<p>
										Integer vitae justo eget magna fermentum iaculis eu non.
										Eget felis eget nunc lobortis mattis aliquam faucibus purus.
										Porttitor lacus luctus accumsan tortor. Viverra adipiscing
										at in tellus integer. Consectetur a erat nam at lectus urna
										duis. Pharetra convallis posuere morbi leo. Pellentesque eu
										tincidunt tortor aliquam nulla facilisi cras fermentum. Enim
										ut tellus elementum sagittis. Faucibus scelerisque eleifend
										donec pretium vulputate. Volutpat ac tincidunt vitae semper.
										Tincidunt arcu non sodales neque. Velit egestas dui id
										ornare arcu odio.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Privacy ends here */}
			<Footer />
		</>
	);
};

export default Privacy;
